import { render, staticRenderFns } from "./calculate.vue?vue&type=template&id=3564ca89&"
import script from "./calculate.vue?vue&type=script&lang=js&"
export * from "./calculate.vue?vue&type=script&lang=js&"
import style0 from "./calculate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports